import { Tenancy } from './types';
const TENANCY_IDS = Object.values(Tenancy);
export function resolveTenancy(value, fallback = Tenancy.DEV) {
    return value && TENANCY_IDS.includes(value)
        ? value
        : fallback;
}
export function tenancyFromSearch(search) {
    const value = new URLSearchParams(search).get('tenancy') ?? undefined;
    if (!value || !TENANCY_IDS.includes(value))
        return undefined;
    return value;
}
